var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('swiper',_vm._l((_vm.banners),function(item,index){return _c('slide',{key:index},[_c('img',{staticClass:"lunbo",attrs:{"src":item.image_url,"alt":""}})])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }